import React from 'react';
import ReactMarkdown from 'react-markdown';
import Text from '../Text/Text';
import './MarkdownText.scss';

interface Props {
    content: string;
    textHandler?: any;
}

const LinkHandler = (props) => (
    <a target="_blank" href={props.href}>
        {props.children}
    </a>
);

const TextHandler = (props) => (
    <Text tag="p" size={props.size}>
        {props.children}
    </Text>
);

const MarkdownText: React.FC<Props> = ({ content, textHandler }) => {
    return (
        <ReactMarkdown
            children={content}
            components={{
                a: LinkHandler,
                p: textHandler || TextHandler,
            }}
            className="MarkdownText"
        />
    );
};

export default MarkdownText;
